import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import Spinner from 'components/spinner/Spinner';
import { APIVersion, compareOBVersions, OBLatestVersion } from 'drugData/lookupDrugs';
import { downloadOrangeBook, setOrangeBookFromJson } from 'drugData/orangeBookService';
import { checkOnline } from 'helpers/apiHelpers';

export default function UpdateOBData() {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);

    const comp = compareOBVersions();
    //console.log(obVersion, apiVersion, comp);
    var updateFlag = (comp > 0);
    var onlineFlag = checkOnline();

    async function onSubmit() {
        console.log('submitting');
        setSubmitted(true);
        const result = await downloadOrangeBook();

        setSubmitted(false);
    }

    async function reloadDb() {
        setSubmitted(true);
        var result = await setOrangeBookFromJson()
        console.log("Load DB from JSON: ", result)
        setSubmitted(false);
    }

    function handleClose() {
        navigate("/")

    }

    if (!comp || submitted) return (<Spinner />);

    return (
        <div className='mt-8 text-center font-bold text-2xl '>
            {/* style={{textAlign: 'center', height: '400px', color: 'black', marginTop: '50px'}}> */}
            Update Orange Book Data
            <div className='mt-4 text-xl font-semibold'>
                Current Orange Book Version:
            </div>
            <div className='mt-4'>
                {OBLatestVersion}
            </div>
            <div className='mt-4 text-xl font-semibold'>
                Latest Orange Book Version:
            </div>
            <div className='mt-4'>
                {APIVersion}
            </div>
            {onlineFlag && updateFlag &&
                <div className='mt-6'>
                    <button
                        className='plainBtn small:ml-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-green-600'
                        onClick={() => onSubmit()}
                        disabled={submitted}>
                        Update Orange Book Data
                    </button>
                </div>
            }
            {!onlineFlag &&
                <div className='mt-6'>
                    No Internet Connection<br/>Unable to Check Version
                </div>
            }
            {onlineFlag && !updateFlag &&
                <div className='mt-6'>
                    No Update Needed
                </div>
            }
            <div className='mt-12'>
                <button
                    onClick={handleClose}
                    className='plainBtn mr-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-red-600'
                >
                    Cancel
                </button>
            </div>

            <div className='mt-24'>
                <button
                    onClick={reloadDb}
                    className='plainBtn mr-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-orange-500'
                >
                    Copy JSON to DB
                </button>
            </div>
        </div>
    );
}
